import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
// import { Link } from 'react-router-dom'
import moment from 'moment'
import Alert from 'react-s-alert'
import { UserContext } from '../../UserContext'
import AuthGroupWrapper from '../Auth/AuthGroupWrapper'


// Utilties on the admin page...





const Utilities = (props) => {

  const [edit, setEdit] = useState('')
  const { activeUser } = useContext(UserContext);


  const { utility, utilityLocation, modMake, modModel, modSize, ppw, modId, invId, hasRebate, maxOffset, maxSystemSize, rebateFixed, rebateMax, rebatePerWatt, rebateType, invModel, invType, loan1, loan2, term1, term2, int1, int2, loanId1, loanId2, utility_id, hasNest, hasAdder, cashPpw, hasUtilityDiscount, user, timeStamp, tierType, surcharge, tier1, tier2, tier3, tier4, sTier1, sTier2, sTier3, sTier4, wTier1, wTier2, wTier3, wTier4, tierAmount, sTierAmount, wTierAmount, tier1Amount, tier2Amount, tier3Amount, tier4Amount, sTier1Amount, sTier2Amount, sTier3Amount, sTier4Amount, wTier1Amount, wTier2Amount, wTier3Amount, wTier4Amount, utilityLseId, hasPpa } = props.utility

  const [moduleId, setModuleId] = useState(modId)
  const [inverterId, setInverterId] = useState(invId)
  const [loan_id1, setLoan_id1] = useState(loanId1)
  const [loan_id2, setLoan_id2] = useState(loanId2)
  const [teamPpw, setTeamPpw] = useState(+ppw)
  const [teamCashPpw, setTeamCashPpw] = useState(+cashPpw)
  const [rebate, setRebate] = useState(hasRebate)
  const [rType, setRType] = useState(rebateType)
  const [rPerWatt, setRPerWatt] = useState(rebatePerWatt)
  const [rFixed, setRFixed] = useState(rebateFixed)
  const [rCap, setRCap] = useState(rebateMax)
  const [maxOff, setMaxOff] = useState(maxOffset)
  const [maxSystem, setMaxSystem] = useState(maxSystemSize)
  const [nest, setNest] = useState(+hasNest)
  const [location, setLocation] = useState(utilityLocation)
  const [utilityName, setUtilityName] = useState(utility)
  const [adder, setAdder] = useState(hasAdder)
  const [preferredUtility, setPreferredUtility] = useState(hasUtilityDiscount)
  const [time, setTime] = useState('')
  const [newUser, setNewUser] = useState('')
  const [lseId, setLseId] = useState(utilityLseId)
  const [ppa, setPpa] = useState(hasPpa)

  const [tType, setTType] = useState(tierType)
  const [charge, setCharge] = useState(+surcharge)
  const [taxAmount] = useState(1)
  const [t1, setT1] = useState(+tier1)
  const [t2, setT2] = useState(+tier2)
  const [t3, setT3] = useState(+tier3)
  const [t4, setT4] = useState(+tier4)
  const [sT1, setST1] = useState(+sTier1)
  const [sT2, setST2] = useState(+sTier2)
  const [sT3, setST3] = useState(+sTier3)
  const [sT4, setST4] = useState(+sTier4)
  const [wT1, setWT1] = useState(+wTier1)
  const [wT2, setWT2] = useState(+wTier2)
  const [wT3, setWT3] = useState(+wTier3)
  const [wT4, setWT4] = useState(+wTier4)
  const [tAmount, setTAmount] = useState(+tierAmount)
  const [sTAmount, setSTAmount] = useState(+sTierAmount)
  const [wTAmount, setWTAmount] = useState(+wTierAmount)
  const [t1Amount, setT1Amount] = useState(+tier1Amount)
  const [t2Amount, setT2Amount] = useState(+tier2Amount)
  const [t3Amount, setT3Amount] = useState(+tier3Amount)
  const [t4Amount,] = useState(+tier4Amount)
  const [sT1Amount, setST1Amount] = useState(+sTier1Amount)
  const [sT2Amount, setST2Amount] = useState(+sTier2Amount)
  const [sT3Amount, setST3Amount] = useState(+sTier3Amount)
  const [sT4Amount] = useState(+sTier4Amount)
  const [wT1Amount, setWT1Amount] = useState(+wTier1Amount)
  const [wT2Amount, setWT2Amount] = useState(+wTier2Amount)
  const [wT3Amount, setWT3Amount] = useState(+wTier3Amount)
  const [wT4Amount] = useState(+wTier4Amount)

  const [viewRates, setViewRates] = useState('')


  useEffect(() => {
    setNewUser(`${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`)
  }, [])

  // console.log(newUser)

  const timer = () => {
    setTime(moment().format('MM/DD/YY, h:mm a'))
  }

  // console.log(time)

  const rebateDisplay = () => {
    if (rebateType === 'Fixed') {
      return (+rebateFixed).toLocaleString(undefined, { style: "currency", currency: "USD" })
    } else if (rebateType === 'Per Watt A/C' || rebateType === 'Per Watt D/C') {
      return `${(+rebatePerWatt).toLocaleString(undefined, { style: "currency", currency: "USD" })}`
    }
  }

  const update = () => {
    if (!newUser) {
      return Alert.error(`Please select a user to update ${utility}.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    } updateUtility(); setEdit(!edit)
  }

  const updateUtility = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_utility', utility_name: utilityName, ppw: teamPpw, cash_ppw: teamCashPpw, utility_location: location, has_nest: nest, has_rebate: rebate, rebate_type: rType, rebate_per_watt: rPerWatt, rebate_fixed_amount: rFixed, rebate_max: rCap, max_offset: maxOff, max_system_size: maxSystem, inv_id: inverterId, mod_id: moduleId, loan_id: loan_id1, loan_id2: loan_id2, has_adder: adder, adder_id: 1, utility_id: utility_id, has_utility_discount: preferredUtility, user: newUser, time_stamp: time, tier_type: tType, surcharge: charge, tax: taxAmount, tier_1: t1, tier_2: t2, tier_3: t3, tier_4: t4, s_tier_1: sT1, s_tier_2: sT2, s_tier_3: sT3, s_tier_4: sT4, w_tier_1: wT1, w_tier_2: wT2, w_tier_3: wT3, w_tier_4: wT4, tier_amount: tAmount, s_tier_amount: sTAmount, w_tier_amount: wTAmount, tier_1_amount: t1Amount, tier_2_amount: t2Amount, tier_3_amount: t3Amount, tier_4_amount: t4Amount, s_tier_1_amount: sT1Amount, s_tier_2_amount: sT2Amount, s_tier_3_amount: sT3Amount, s_tier_4_amount: sT4Amount, w_tier_1_amount: wT1Amount, w_tier_2_amount: wT2Amount, w_tier_3_amount: wT3Amount, w_tier_4_amount: wT4Amount, has_ppa: ppa, lse_id: lseId })
      .then((res) => {
        props.getUtilities()
        console.log(res)
      })
  }


  // console.log(location)

  return (
    <div className='items' >
      <h3>{utility}</h3>
      {edit ? (
        <>
          <div>
            <span>{utility} </span>
            <input className='input' placeholder='name' onChange={e => setUtilityName(e.target.value)} />
          </div>
          <div>
            <span>Location (state): {utilityLocation}</span>
            <select className='input' onChange={e => setLocation(e.target.value)}>
              <option style={{ display: 'none' }} >
                Select State
              </option>
              <option value="Alabama">Alabama</option>
              <option value="Alaska">Alaska</option>
              <option value="Arizona">Arizona</option>
              <option value="Arkansas">Arkansas</option>
              <option value="California">California</option>
              <option value="Colorado">Colorado</option>
              <option value="Connecticut">Connecticut</option>
              <option value="Delaware">Delaware</option>
              <option value="Florida">Florida</option>
              <option value="Georgia">Georgia</option>
              <option value="Hawaii">Hawaii</option>
              <option value="Idaho">Idaho</option>
              <option value="Illinois">Illinois</option>
              <option value="Indiana">Indiana</option>
              <option value="Iowa">Iowa</option>
              <option value="Kansas">Kansas</option>
              <option value="Kentucky">Kentucky</option>
              <option value="Louisiana">Louisiana</option>
              <option value="Maine">Maine</option>
              <option value="Maryland">Maryland</option>
              <option value="Massachusetts">Massachusetts</option>
              <option value="Michigan">Michigan</option>
              <option value="Minnesota">Minnesota</option>
              <option value="Mississippi">Mississippi</option>
              <option value="Missouri">Missouri</option>
              <option value="Montana">Montana</option>
              <option value="Nebraska">Nebraska</option>
              <option value="Nevada">Nevada</option>
              <option value="New Hampshire">New Hampshire</option>
              <option value="New Jersey">New Jersey</option>
              <option value="New Mexico">New Mexico</option>
              <option value="New York">New York</option>
              <option value="North Carolina">North Carolina</option>
              <option value="North Dakota<">North Dakota</option>
              <option value="Ohio">Ohio</option>
              <option value="Oklahoma">Oklahoma</option>
              <option value="Oregon">Oregon</option>
              <option value="Pennsylvania">Pennsylvania</option>
              <option value="Rhode Island">Rhode Island</option>
              <option value="South Carolina">South Carolina</option>
              <option value="South Dakota">South Dakota</option>
              <option value="Tennessee">Tennessee</option>
              <option value="Texas">Texas</option>
              <option value="Utah">Utah</option>
              <option value="Vermont">Vermont</option>
              <option value="Virginia">Virginia</option>
              <option value="Washington">Washington</option>
              <option value="West Virginia">West Virginia</option>
              <option value="Wisconsin">Wisconsin</option>
              <option value="Wyoming">Wyoming</option>
            </select>

          </div>
          <div>
            <span>Max System Size: {maxSystem ? (`${(+maxSystemSize).toLocaleString(undefined)} watts`) : ('N/A')} </span>
            <input className='input' placeholder='max size in watts' onChange={e => setMaxSystem(e.target.value)} ></input>
          </div>
          <div>
            <span>Max Usage Offset: {maxOff ? (`${maxOffset}%`) : ('N/A')} </span>
            <input className='input' placeholder='max offset' onChange={e => setMaxOff(e.target.value)} ></input>
          </div>
          <form >
            <span>Has PPA: </span>
            <input className='input' type="radio" name='ppa' onChange={e => setPpa('1')} checked={ppa === '1' ? 'checked' : ''} />
            <span>Yes</span>
            <input className='input' type="radio" name='ppa' onChange={e => setPpa('0')} checked={ppa === '0' ? 'checked' : ''} />
            <span>No</span>
          </form>
          <form >
            <span>$.40/w Preferred Utility Discount: </span>
            <input className='input' type="radio" name='preferredUtility' onChange={e => setPreferredUtility('1')} checked={preferredUtility === '1' ? 'checked' : ''} />
            <span>Yes</span>
            <input className='input' type="radio" name='preferredUtility' onChange={e => setPreferredUtility('0')} checked={preferredUtility === '0' ? 'checked' : ''} />
            <span>No</span>
          </form>
          <form >
            <span>Rebate: </span>
            <input className='input' type="radio" name='rebate' onChange={e => setRebate('1')} checked={rebate === '1' ? 'checked' : ''} />
            <span>Yes</span>
            <input className='input' type="radio" name='rebate' onChange={e => setRebate('0')} checked={rebate === '0' ? 'checked' : ''} />
            <span>No</span>
          </form>
          {rebate === '1' ? (
            <>
              <div>
                <select onChange={e => setRType(e.target.value)} className='input'>
                  <option style={{ display: 'none' }}>Rebate Type </option>
                  <option value='Per Watt D/C'>Per Watt D/C</option>
                  <option value='Per Watt A/C'>Per Watt A/C</option>
                  <option value='Fixed'>Fixed</option>
                </select>
              </div>
              <div>
                <span>Rebate Amount </span>
                <input className='input' onChange={e => (rType === 'Fixed' ? setRFixed(e.target.value) : rType === 'Per Watt D/C' || rType === 'Per Watt A/C' ? setRPerWatt(e.target.value) : (''))}
                  placeholder={rType === 'Fixed' ? ('fixed') : rType === 'Per Watt D/C' ? ('Per Watt D/C') : rType === 'Per Watt A/C' ? ('Per Watt A/C') : ('')} ></input>
              </div>
              <div>
                <span>Rebate Cap </span>
                <input className='input' onChange={e => setRCap(e.target.value)} placeholder='rebate cap' ></input>
              </div>
            </>
          ) : (
            <>
            </>
          )}
          <div>
            <span>Rate Information:</span>
          </div>
          <div className='addItem'>
            <div style={{ alignItems: 'flex-end' }} className='addItem1'>
              <span>Surcharge: {surcharge}</span>
              <span>Tier Schedule: {tierType} </span>
            </div>
            <div className='addItem1'>
              <input className='input' onChange={e => setCharge(+e.target.value)} placeholder='surcharge' ></input>
              <select onChange={e => setTType(e.target.value)} className='input'>
                <option style={{ display: 'none' }}>Tier Schedule</option>
                <option value='Annual'>Annual</option>
                <option value='Split'>Winter/Summer</option>
              </select>
            </div>
          </div>
          <div className='addItem'>
            {tType === 'Split' ? (
              <>
                <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                  <span>Amount of Summer Tiers: {sTierAmount}</span>
                  {sTAmount === 4 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(sTier1).toLocaleString(undefined, { style: "currency", currency: "USD" })} </span>
                      <span>Tier 1 $ per kWh: ${(+sTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {sTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+sTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {sTier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+sTier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {sTier3Amount} </span>
                      <span>Tier 4 $ per kWh: ${(+sTier4).toFixed(6)}</span>
                      <span>Tier 4 kWh Amount: {+sTier3Amount + 1}+ </span>
                    </>
                  ) : sTAmount === 3 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+sTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {sTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+sTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {sTier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+sTier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {+sTier2Amount + 1}+ </span>
                    </>
                  ) : sTAmount === 2 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+sTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {sTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+sTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {+sTier1Amount + 1}+ </span>
                    </>
                  ) : sTAmount === 1 ? (
                    <>
                      <span>Tier 1 $ per kWh for all kWh: ${(+sTier1).toFixed(6)} </span>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                  <span>Amount of Winter Tiers: {wTierAmount} </span>
                  {wTAmount === 4 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+wTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {wTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+wTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {wTier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+wTier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {wTier3Amount} </span>
                      <span>Tier 4 $ per kWh: ${(+wTier4).toFixed(6)} </span>
                      <span>Tier 4 kWh Amount: {+wTier3Amount + 1}+ </span>
                    </>
                  ) : wTAmount === 3 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+wTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {wTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+wTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {wTier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+wTier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {+wTier2Amount + 1}+ </span>
                    </>
                  ) : wTAmount === 2 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+wTier1).toFixed(6)} </span>
                      <span>Tier 1 kWh Amount: {wTier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+wTier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {+wTier1Amount + 1}+ </span>
                    </>
                  ) : wTAmount === 1 ? (
                    <>
                      <span>Tier 1 $ per kWh for all kWh: ${(+wTier1).toFixed(6)} </span>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                </div>
                <div className='addItem1'>
                  <select onChange={e => setSTAmount(+e.target.value)} className='input'>
                    <option style={{ display: 'none' }}>Summer Tiers</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                  </select>
                  {sTAmount === 4 ? (
                    <>
                      <input className='input' onChange={e => setST1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setST1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setST2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setST2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setST3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <input className='input' onChange={e => setST3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                      <input className='input' onChange={e => setST4(+e.target.value)} placeholder='4 per kWh' ></input>
                      <span>{sTier3Amount ? `${sT3Amount + 1}+` : '-'}</span>
                    </>
                  ) : sTAmount === 3 ? (
                    <>
                      <input className='input' onChange={e => setST1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setST1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setST2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setST2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setST3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <span>{sTier2Amount ? `${sT2Amount + 1}+` : '-'}</span>
                    </>
                  ) : sTAmount === 2 ? (
                    <>
                      <input className='input' onChange={e => setST1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setST1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setST2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <span>{sTier1Amount ? `${sT1Amount + 1}+` : '-'}</span>
                    </>
                  ) : sTAmount === 1 ? (
                    <>
                      <input className='input' onChange={e => setST1(+e.target.value)} placeholder='1 per kWh' ></input>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                  <select onChange={e => setWTAmount(+e.target.value)} className='input'>
                    <option style={{ display: 'none' }}>Winter Tiers</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                  </select>
                  {wTAmount === 4 ? (
                    <>
                      <input className='input' onChange={e => setWT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setWT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setWT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setWT2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setWT3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <input className='input' onChange={e => setWT3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                      <input className='input' onChange={e => setWT4(+e.target.value)} placeholder='4 per kWh' ></input>
                      <span>{wTier3Amount ? `${wT3Amount + 1}+` : '-'}</span>
                    </>
                  ) : wTAmount === 3 ? (
                    <>
                      <input className='input' onChange={e => setWT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setWT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setWT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setWT2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setWT3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <span>{wTier2Amount ? `${wT2Amount + 1}+` : '-'}</span>
                    </>
                  ) : wTAmount === 2 ? (
                    <>
                      <input className='input' onChange={e => setWT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setWT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setWT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <span>{wTier1Amount ? `${wT1Amount + 1}+` : '-'}</span>
                    </>
                  ) : wTAmount === 1 ? (
                    <>
                      <input className='input' onChange={e => setWT1(+e.target.value)} placeholder='1 per kWh' ></input>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                </div>
              </>
            ) : tType === 'Annual' ? (
              <>
                <div style={{ alignItems: 'flex-end' }} className='addItem1'>
                  <span>Amount of Tiers: {tierAmount} </span>
                  {tAmount === 4 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+tier1).toFixed(6)}</span>
                      <span>Tier 1 kWh Amount: {tier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+tier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {tier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+tier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {tier3Amount} </span>
                      <span>Tier 4 $ per kWh: ${(+tier4).toFixed(6)} </span>
                      <span>Tier 4 kWh Amount: {+tier3Amount + 1}+</span>
                    </>
                  ) : tAmount === 3 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+tier1).toFixed(6)}</span>
                      <span>Tier 1 kWh Amount: {tier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+tier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {tier2Amount} </span>
                      <span>Tier 3 $ per kWh: ${(+tier3).toFixed(6)} </span>
                      <span>Tier 3 kWh Amount: {+tier2Amount + 1}+ </span>
                    </>
                  ) : tAmount === 2 ? (
                    <>
                      <span>Tier 1 $ per kWh: ${(+tier1).toFixed(6)}</span>
                      <span>Tier 1 kWh Amount: {tier1Amount} </span>
                      <span>Tier 2 $ per kWh: ${(+tier2).toFixed(6)} </span>
                      <span>Tier 2 kWh Amount: {+tier1Amount + 1}+ </span>
                    </>
                  ) : tAmount === 1 ? (
                    <>
                      <span>Tier 1 $ per kWh for all kWh: ${(+tier1).toFixed(6)} </span>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                </div>
                <div className='addItem1'>
                  <select onChange={e => setTAmount(+e.target.value)} className='input'>
                    <option style={{ display: 'none' }}>Tiers</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                  </select>
                  {tAmount === 4 ? (
                    <>
                      <input className='input' onChange={e => setT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setT2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setT3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <input className='input' onChange={e => setT3Amount(+e.target.value)} placeholder='3 kWh amount' ></input>
                      <input className='input' onChange={e => setT4(+e.target.value)} placeholder='4 per kWh' ></input>
                      <span>{tier3Amount ? `${t3Amount + 1}+` : '-'}</span>
                    </>
                  ) : tAmount === 3 ? (
                    <>
                      <input className='input' onChange={e => setT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <input className='input' onChange={e => setT2Amount(+e.target.value)} placeholder='2 kWh amount' ></input>
                      <input className='input' onChange={e => setT3(+e.target.value)} placeholder='3 per kWh' ></input>
                      <span>{tier2Amount ? `${t2Amount + 1}+` : '-'}</span>
                    </>
                  ) : tAmount === 2 ? (
                    <>
                      <input className='input' onChange={e => setT1(+e.target.value)} placeholder='1 per kWh' ></input>
                      <input className='input' onChange={e => setT1Amount(+e.target.value)} placeholder='1 kWh amount' ></input>
                      <input className='input' onChange={e => setT2(+e.target.value)} placeholder='2 per kWh' ></input>
                      <span>{tier1Amount ? `${t1Amount + 1}+` : '-'}</span>
                    </>
                  ) : tAmount === 1 ? (
                    <>
                      <input className='input' onChange={e => setT1(+e.target.value)} placeholder='1 per kWh' ></input>
                    </>
                  ) : (
                    <>
                    </>
                  )}

                </div>
              </>
            ) : (
              <>
              </>
            )}
          </div>
          <div>
            <span>LSE ID: {lseId ? (`${lseId}`) : ('N/A')} </span>
            <input className='input' placeholder='LSE ID' onChange={e => setLseId(e.target.value)} ></input>
          </div>
          <div>
            <button type='submit' onClick={() => update()}>Update Utility</button>
            <button onClick={() => setEdit(!edit)}>Cancel</button>
          </div>
        </>
      ) : (
        <>
          <div>
            <span>Location (state): {utilityLocation}</span>
          </div>
          <div>
            <span>Max System Size: {maxSystem ? (`${(+maxSystem).toLocaleString(undefined)} watts`) : ('N/A')}</span>
          </div>
          <div>
            <span>Max Usage Offset: {maxOff ? (`${+maxOff}%`) : ('N/A')}</span>
          </div>
          <div>
            <span>Has PPA: </span>
            <span>{ppa === '1' ? `Yes` : 'No'}</span>
          </div>
          <div>
            <span>$.40/w Preferred Utility Discount: </span>
            <span>{preferredUtility === '1' ? `Yes` : 'No'}</span>
          </div>
          <div>
            <span>Rebate: </span>
            <span>{rebate === '1' ? `Yes, ${rebateDisplay()} ${rebateType} ` : 'No'}</span>
          </div>
          {rebate === '1' ? (
            <span>Rebate Cap: {rebateMax ? `Yes, ${(+rebateMax).toLocaleString(undefined, { style: "currency", currency: "USD" })} ` : 'No'}</span>
          ) : (
            <>
            </>
          )}
          <div>
            <span>LSE ID: </span>
            <span>{utilityLseId}</span>
          </div>
          {viewRates ? (
            <>
              {!tierType ? (
                <>
                  <span>Custom Built in Proposalist. Speak with Ryan Reese for details.</span>
                </>
              ) : (
                <>
                  <span>Rate Schedule Type: {tierType}</span>
                  <span>Monthly Surcharge: ${surcharge.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                  {tierType === 'Split' ? (
                    <>
                      <span>Tiers:</span>
                      {sTierAmount === '4' ? (
                        <>
                          <span>Summer</span>
                          <span>Tier 1: 0-{+sTier1Amount} kWh at ${+sTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+sTier1Amount + 1)}-{sTier2Amount} kWh at ${sTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+sTier2Amount + 1)}-{sTier3Amount} kWh at ${sTier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 4: {(+sTier3Amount + 1)}+ kWh at ${sTier4.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      ) : sTierAmount === '3' ? (
                        <>
                          <span>Summer</span>
                          <span>Tier 1: 0-{sTier1Amount} kWh at ${+sTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+sTier1Amount + 1)}-{+sTier2Amount} kWh at ${+sTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+sTier2Amount + 1)}+ kWh at ${+sTier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : sTierAmount === '2' ? (
                        <>
                          <span>Summer</span>
                          <span>Tier 1: 0-{sTier1Amount} kWh at ${+sTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+sTier1Amount + 1)}+ kWh at ${+sTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : (
                        <>
                          <span>Summer</span>
                          <span>All kWh at ${+sTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      )}
                      {wTierAmount === '4' ? (
                        <>
                          <span>Winter</span>
                          <span>Tier 1: 0-{wTier1Amount} kWh at ${+wTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+wTier1Amount + 1)}-{+wTier2Amount} kWh at ${+wTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+wTier2Amount + 1)}-{+wTier3Amount} kWh at ${+wTier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 4: {(+wTier3Amount + 1)}+ kWh at ${+wTier4.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      ) : wTierAmount === '3' ? (
                        <>
                          <span>Winter</span>
                          <span>Tier 1: 0-{wTier1Amount} kWh at ${+wTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+wTier1Amount + 1)}-{+wTier2Amount} kWh at ${+wTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+wTier2Amount + 1)}+ kWh at ${+wTier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : wTierAmount === '2' ? (
                        <>
                          <span>Winter</span>
                          <span>Tier 1: 0-{+wTier1Amount} kWh at ${+wTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+wTier1Amount + 1)}+ kWh at ${+wTier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : (
                        <>
                          <span>Winter</span>
                          <span>All kWh at ${+wTier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <span>Tiers:</span>
                      {tierAmount === '4' ? (
                        <>
                          <span>Tier 1: 0-{tier1Amount} kWh at ${+tier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+tier1Amount + 1)}-{+tier2Amount} kWh at ${+tier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+tier2Amount + 1)}-{+tier3Amount} kWh at ${+tier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 4: {(+tier3Amount + 1)}+ kWh at ${+tier4.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      ) : tierAmount === '3' ? (
                        <>
                          <span>Tier 1: 0-{tier1Amount} kWh at ${+tier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+tier1Amount + 1)}-{+tier2Amount} kWh at ${+tier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 3: {(+tier2Amount + 1)}+ kWh at ${+tier3.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : tierAmount === '2' ? (
                        <>
                          <span>Tier 1: 0-{tier1Amount} kWh at ${+tier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                          <span>Tier 2: {(+tier1Amount + 1)}+ kWh at ${+tier2.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>

                        </>
                      ) : (
                        <>
                          <span>All kWh at ${+tier1.toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
              <button onClick={() => { setViewRates(!viewRates) }}>Close</button>
            </>
          ) : (
            <>
              <button onClick={() => { setViewRates(!viewRates) }}>View Rate Info</button>
            </>
          )}
          <AuthGroupWrapper requiredGroups={['Super-Admin']}>
            <div>
              <button onClick={() => { setEdit(!edit); timer() }}>Edit {utility} Info</button>
            </div>
          </AuthGroupWrapper>
          <div>
            <span>Last edited by {user} on {timeStamp}</span>
          </div>
        </>
      )
      }
    </div>
  )
}
export default Utilities